module.exports = __webpack_public_path__ + "static/img/aboutUs2.9e1b04dc.png";